import { FC } from 'react';
import { useRoles } from 'store/permissions';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'multiple' | 'searchable'
>;

export const RolesFilter: FC<Props> = (props) => {
  const { data: roles, isLoading } = useRoles();

  return (
    <SelectFilter
      {...props}
      options={
        roles?.items.map((role) => ({
          key: role.id,
          label: role.name,
        })) ?? []
      }
      loadingOptions={isLoading}
      multiple
      searchable={false}
    />
  );
};
